import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { autocomplete } from "@/graphql/queries";
import { create } from "zustand";
import type { State } from "@/types/common";
import type { AutocompleteQuery } from "@/API";
import type { GraphQLError } from "graphql";

const client = generateClient();

export const autoCompleteSearchBarState = create<State<AutocompleteQuery>>(
  () => ({
    data: null,
    isLoading: false,
    error: null,
    isFetching: false,
  }),
);

export const autoCompleteSearchBarStateIsloading = () =>
  autoCompleteSearchBarState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const autoCompleteSearchBarStateIsError = (error: GraphQLError[]) =>
  autoCompleteSearchBarState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const autoCompleteSearchBarStateIsSuccess = (
  queryResult: AutocompleteQuery,
) =>
  autoCompleteSearchBarState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
  }));

export const resetAutoCompleteSearchBarState = () =>
  autoCompleteSearchBarState.setState(() =>
    autoCompleteSearchBarState.getInitialState(),
  );

export type searchForAutoCompleteSearchBarParams = {
  search: string;
};

export const searchForAutoCompleteSearchBar = async ({
  search,
}: searchForAutoCompleteSearchBarParams) => {
  autoCompleteSearchBarStateIsloading();

  try {
    const response = await client.graphql({
      query: autocomplete,
      variables: {
        value: search,
      },
    });

    autoCompleteSearchBarStateIsSuccess(response.data as AutocompleteQuery);
  } catch (e: unknown) {
    const graphQl = e as GraphQLResult<AutocompleteQuery>;
    autoCompleteSearchBarStateIsError(graphQl.errors as GraphQLError[]);
  }
};
